import { Button, Input, Modal, Select, Slider } from 'antd'
import Title from 'antd/es/typography/Title';
import React, { useEffect, useState } from 'react'
import { COST_SAVINGS_MARKS } from '../../screens/Rankings/RankingsUtils';
import { historyAPI } from '../../API/HistoryAPI';
import { EscalationCompletedAPI } from '../../API/EscalationCompletedAPI';
import { mntcCheck, mntcCheckInterval, mntcCheckPackage, mntcCheckPackageInterval } from '../../screens/History/HistoryUtils';

const INITIAL_OBJECT = {
    cat: '',
    // yieldValue: 90,
    yieldValueFrom: 0,
    yieldValueTo: 100,
    maintenanceCheck: '',
    specType: '',
    maintenanceCheckPackage: '',
    maintenanceCheckInterval: '',
    maintenanceCheckPackageInterval: ''
}

export const HistoryFilter = ({ open, setOpen, setListData, defualtData, filteredValues, setFilteredvalues, serachVal, setFilterStatus, selectedMonth, page,pageSize,pageNo }) => {
    const [inputElements, setInputElements] = useState(INITIAL_OBJECT);

    // async function applyFun() {
    //     const filterArr = defualtData.filter(ele => (
    //         (!inputElements.cat.trim() || String(ele.fec).toLowerCase().includes(String(inputElements.cat.trim()).toLowerCase())) &&
    //         (!serachVal.trim() || ele.spec_concat.toLowerCase().includes(serachVal.trim().toLowerCase()))
    //     ));

    //     setListData(filterArr);
    //     setFilteredvalues({ cat: inputElements.cat });
    //     setFilterStatus(!!inputElements.cat.trim());
    //     setOpen(false);
    // }
    async function applyFun() {

        const bodyData = page === "EscalationCompleted" ? {
            fec: inputElements.cat,
            spec_no: serachVal,
            spec_type: inputElements.specType,
            yield_percentage_start: inputElements.yieldValueFrom,
            yield_percentage_end: inputElements.yieldValueTo,
            mntc_check: inputElements.maintenanceCheck,
            mntc_check_package: inputElements.maintenanceCheckPackage,
            mntc_check_interval: inputElements.maintenanceCheckInterval,
            mntc_check_package_interval: inputElements.maintenanceCheckPackageInterval,
             page: pageNo,
        per_page: pageSize
        } : {
            month: selectedMonth,
            fec: inputElements.cat,
            spec_no: serachVal,
            spec_type: inputElements.specType,
            yield_percentage_start: inputElements.yieldValueFrom,
            yield_percentage_end: inputElements.yieldValueTo,
            mntc_check: inputElements.maintenanceCheck,
            mntc_check_package: inputElements.maintenanceCheckPackage,
            mntc_check_interval: inputElements.maintenanceCheckInterval,
            mntc_check_package_interval: inputElements.maintenanceCheckPackageInterval,
              page: pageNo,
        per_page: pageSize
        }

        try {

            const res = page === "EscalationCompleted" ? await EscalationCompletedAPI.escalationListFilter(bodyData) : await historyAPI.rankHistoryFilter(bodyData);

            if (res?.data?.data) {
                setListData(res.data.data);
            }

            setFilteredvalues({
                ...inputElements
            });

            setFilterStatus(!!inputElements.cat.trim());

            setOpen(false);

        } catch (error) {
            console.error(error);
        }
    }

    function cancelFun() {
        setInputElements(INITIAL_OBJECT)
        setListData(defualtData)
        setFilteredvalues({
            // cat: '',
            cat: '',
            status: [],
            task: [],
            specType: '',
            // yieldValue: 90,
            yieldValueFrom: 0,
            yieldValueTo: 100,
            maintenanceCheck: '',
            maintenanceCheckPackage: '',
            maintenanceCheckInterval: '',
            maintenanceCheckPackageInterval: ''
        })

        const filterArr = defualtData.filter((ele) => {
            return (
                (!serachVal.trim() || ele.spec_concat.toLowerCase().includes(serachVal.trim().toLowerCase()))
            )
        })
        setListData(filterArr)
        setFilterStatus(false)
        setOpen(false)
    }

    function backFun() {
        setInputElements(INITIAL_OBJECT)
        setOpen(false)
    }
    const handleFromChange = (e) => {
        const value = Number(e.target.value);
        setInputElements((prev) => ({
            ...prev,
            yieldValueFrom: value,
        }));
    };

    const handleToChange = (e) => {
        const value = Number(e.target.value);
        setInputElements((prev) => ({
            ...prev,
            yieldValueTo: value,
        }));
    };

    const handleSliderChange = (value) => {
        setInputElements((prev) => ({
            ...prev,
            yieldValueFrom: value[0],
            yieldValueTo: value[1],
        }));
    };
    useEffect(() => {
        if (open) {
            setInputElements({
                // cat: filteredValues.cat,
                cat: filteredValues.cat,
                status: filteredValues.status,
                task: filteredValues.task,
                specType: filteredValues.specType,
                // yieldValue: inputElements.yieldValue,
                yieldValueFrom: filteredValues.yieldValueFrom,
                yieldValueTo: filteredValues.yieldValueTo,
                maintenanceCheck: filteredValues.maintenanceCheck,
                maintenanceCheckPackage: filteredValues.maintenanceCheckPackage,
                maintenanceCheckInterval: filteredValues.maintenanceCheckInterval,
                maintenanceCheckPackageInterval: filteredValues.maintenanceCheckPackageInterval
            })
        }
    }, [open])

    return (
        <Modal
            open={open}
            width='900px'
            okText='Apply'
            cancelText='Clear All'
            onCancel={() => backFun()}
            onOk={applyFun}
            footer={[
                <Button key="back" type='text' onClick={backFun}>
                    Cancel
                </Button>,
                <Button key="submit" type="default" onClick={cancelFun}>
                    Clear All
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    onClick={applyFun}
                >
                    Apply
                </Button>,
            ]}
        >
            {/* <div style={{ padding: '10px' }}>
                <div style={{ marginBottom: '20px', borderBottom: 'solid 1px #80808047' }}>
                    <Title level={5}>Filters</Title>
                </div>
                <div style={{ marginBottom: '15px' }}>
                    <label>FEC</label>
                    <Input value={inputElements.cat} onChange={(e) => {
                        const value = e.target.value.trimStart();
                        setInputElements((prev) => ({
                            ...prev,
                            cat: value,
                        }))
                    }} />
                </div>
                 <div>
                        <label>Yield Percentage</label>
                        <Slider
                            value={inputElements.yieldValue}
                            marks={COST_SAVINGS_MARKS}
                            min={0}
                            max={100}
                            onChange={(e) => {
                                setInputElements((prev) => ({
                                    ...prev,
                                    yieldValue: e,
                                }));
                            }}
                            onChangeComplete={(e) => sliderYieldOnchange(e)}
                        />
                    </div>

                    <div>
                        <label>Maintenance Check</label>
                        <Input
                            value={inputElements.maintenanceCheck}
                            onChange={(e) => {
                                const value = e.target.value.trimStart();
                                setInputElements((prev) => ({
                                    ...prev,
                                    maintenanceCheck: value,
                                }));
                            }}
                        />
                    </div>

                    <div>
                        <label>Maintenance Check Package</label>
                        <Input
                            value={inputElements.maintenanceCheckPackage}
                            onChange={(e) => {
                                const value = e.target.value.trimStart();
                                setInputElements((prev) => ({
                                    ...prev,
                                    maintenanceCheckPackage: value,
                                }));
                            }}
                        />
                    </div>

                    <div>
                        <label>Maintenance Check Interval</label>
                        <Input
                            value={inputElements.maintenanceCheckInterval}
                            onChange={(e) => {
                                const value = e.target.value.trimStart();
                                setInputElements((prev) => ({
                                    ...prev,
                                    maintenanceCheckInterval: value,
                                }));
                            }}
                        />
                    </div>

                    <div>
                        <label>Maintenance Check Package Interval</label>
                        <Input
                            value={inputElements.maintenanceCheckPackageInterval}
                            onChange={(e) => {
                                const value = e.target.value.trimStart();
                                setInputElements((prev) => ({
                                    ...prev,
                                    maintenanceCheckPackageInterval: value,
                                }));
                            }}
                        />
                    </div>
            </div> */}
            <div style={{ padding: '10px' }}>

                <div style={{ marginBottom: '20px', borderBottom: 'solid 1px #80808047' }}>
                    <Title level={5}>Filters</Title>
                </div>

                <div style={{ display: "flex", flexWrap: "wrap", gap: "15px" }}>

                    {/* FEC */}
                    <div style={{ width: "48%" }}>
                        <label>FEC</label>
                        <Input
                            value={inputElements.cat}
                            onChange={(e) => {
                                const value = e.target.value.trimStart();
                                setInputElements((prev) => ({
                                    ...prev,
                                    cat: value,
                                }));
                            }}
                        />
                    </div>

                    {/* Yield Percentage */}
                    <div style={{ width: "48%" }}>
                        <label>Yield Percentage</label>

                        {/* Inputs */}
                        <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
                            <Input
                                value={inputElements.yieldValueFrom}
                                onChange={handleFromChange}
                                style={{ width: "80px" }}
                            />

                            <Input
                                value={inputElements.yieldValueTo}
                                onChange={handleToChange}
                                style={{ width: "80px" }}
                            />
                        </div>

                        {/* Slider */}
                        <Slider
                            range
                            min={0}
                            max={100}
                            marks={COST_SAVINGS_MARKS}
                            value={[inputElements.yieldValueFrom, inputElements.yieldValueTo]}
                            onChange={handleSliderChange}
                        />
                    </div>


                    {/* Maintenance Check */}
                    <div style={{ width: "48%" }}>
                        <label>Maintenance Check</label>
                        <Select
                            // allowClear
                            style={{ background: "#EBEEF8", fontSize: "13px", display: "block", width: "100%" }}
                            value={inputElements.maintenanceCheck}
                            onChange={(value) => {
                                setInputElements((prev) => ({
                                    ...prev,
                                    maintenanceCheck: value,
                                }));
                            }}
                            options={mntcCheck}
                        />
                    </div>

                    {/* Maintenance Check Package */}
                    <div style={{ width: "48%" }}>
                        <label>Maintenance Check Package</label>
                        <Select
                            // allowClear
                            style={{ background: "#EBEEF8", fontSize: "13px", display: "block", width: "100%" }}
                            value={inputElements.maintenanceCheckPackage}
                            onChange={(value) => {
                                setInputElements((prev) => ({
                                    ...prev,
                                    maintenanceCheckPackage: value,
                                }));
                            }}
                            options={mntcCheckPackage}
                        />
                    </div>

                    {/* Maintenance Check Interval */}
                    <div style={{ width: "48%" }}>
                        <label>Maintenance Check Interval</label>
                        <Select
                            // allowClear
                            style={{ background: "#EBEEF8", fontSize: "13px", display: "block", width: "100%" }}
                            value={inputElements.maintenanceCheckInterval}
                            onChange={(value) => {
                                setInputElements((prev) => ({
                                    ...prev,
                                    maintenanceCheckInterval: value,
                                }));
                            }}
                            options={mntcCheckInterval}
                        />
                    </div>

                    {/* Maintenance Check Package Interval */}
                    <div style={{ width: "48%" }}>
                        <label>Maintenance Check Package Interval</label>
                        <Select
                            // allowClear
                            style={{ background: "#EBEEF8", fontSize: "13px", display: "block", width: "100%" }}
                            value={inputElements.maintenanceCheckPackageInterval}
                            onChange={(value) => {
                                setInputElements((prev) => ({
                                    ...prev,
                                    maintenanceCheckPackageInterval: value,
                                }));
                            }}
                            options={mntcCheckPackageInterval}
                        />
                    </div>

                </div>
                <div style={{ width: "48%", marginTop: '10px' }}>
                    <label>Spec Type</label>
                    <Select
                        // mode="multiple"
                        allowClear
                        style={{ background: "#EBEEF8", fontSize: "13px", display: "block" }}
                        value={inputElements.specType}
                        onChange={(e) => {
                            setInputElements((prev) => ({
                                ...prev,
                                specType: e,
                            }));
                        }}
                        options={[
                            { value: "MRBR", label: "MRBR" },
                            { value: "VFX", label: "VFX" },
                        ]}
                    />
                </div>
            </div>
        </Modal>
    )
}
